var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img-lazy',{attrs:{"src":_vm.uri,"loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }